// // export default App;
// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import SummaryCards from './SummaryCards';
// import TotalPetsChart from './TotalPetsChart';
// import PieCharts from './PieCharts';
// import AgeAndReproductiveCharts from './AgeAndReproductiveCharts';
// import VetConditionsChart from './VetConditionsChart';
// import './App.css';

// function App() {
//   const [dashboardData, setDashboardData] = useState(null);

//   useEffect(() => {
//     axios.get('http://13.233.94.30:1994/api/v2/clinic/dashboard/pets', {
//       headers: {
//         Authorization: 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJwYXdzQHZldGluc3RhbnQuY29tIiwiaWQiOjIsInJvbGUiOlt7ImF1dGhvcml0eSI6IlJPTEVfQ0xJTklDIn1dLCJpYXQiOjE3NDk2MzY2ODMsImV4cCI6MTc1MTYzNjY4M30.-XGbYOXdoBouI2r8JIHYODcqbY9T_HujSX__vB5SgDWB7dsZqVq0oFYC-2q8G6y2-at-W6homoLHqcNoHTCrvQ'
//       }
//     })
//     .then(response => setDashboardData(response.data))
//     .catch(error => console.error('Failed to fetch dashboard data', error));
//   }, []);

//   if (!dashboardData) return <p>Loading...</p>;

//   return (
//     <div className="App">
//       <div style={{ padding: '30px', background: '#f8f9fb' }}>
//         <div style={{ padding: '30px 0px' }}>
//           <SummaryCards  />
//         </div>
//         <div style={{ padding: '30px 0px' }}>
//           <TotalPetsChart data={dashboardData} />
//         </div>
//         <div style={{ padding: '30px 0px' }}>
//           <PieCharts data={dashboardData} />
//         </div>
//         <div style={{ padding: '30px 0px' }}>
//           <AgeAndReproductiveCharts data={dashboardData} />
//         </div>
//         <div style={{ padding: '30px 0px' }}>
//           <VetConditionsChart data={dashboardData} />
//         </div>
//       </div>
//     </div>
//   );
// }

// export default App;
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SummaryCards from './SummaryCards';
import TotalPetsChart from './TotalPetsChart';
import PieCharts from './PieCharts';
import AgeAndReproductiveCharts from './AgeAndReproductiveCharts';
import VetConditionsChart from './VetConditionsChart';
// import { fetchDashboardPets } from '../redux/slices/dashboardSlice'; // Adjust path accordingly
import './App.css';
import { fetchDashboardPets } from '../../../../redux/reducers/dashboardSlice';

function Main() {
  const dispatch = useDispatch();
  const { dashboardData, loading, error } = useSelector((state) => state.dashboard);

  useEffect(() => {
    dispatch(fetchDashboardPets());
  }, [dispatch]);

  if (loading && !dashboardData)
    return <p>Loading dashboard data...</p>;

  if (error)
    return <p>Error loading dashboard: {error}</p>;

  return (
    <div className="App">
      <div style={{ padding: '30px', background: '#f8f9fb' }}>
        <div style={{ padding: '30px 0px' }}>
          <SummaryCards />
        </div>
        <div style={{ padding: '30px 0px' }}>
          <TotalPetsChart data={dashboardData} />
        </div>
        <div style={{ padding: '30px 0px' }}>
          <PieCharts data={dashboardData} />
        </div>
        <div style={{ padding: '30px 0px' }}>
          <AgeAndReproductiveCharts data={dashboardData} />
        </div>
        <div style={{ padding: '30px 0px' }}>
          <VetConditionsChart data={dashboardData} />
        </div>
      </div>
    </div>
  );
}

export default Main;